import { permissionApi, roleApi } from './apis';
import {
  GenericItemsResponseInterface,
  PagePermissionEntityInterface,
  RoleEntityInterface,
} from '@types';

export const getRoleById = async (id: string): Promise<RoleEntityInterface> => {
  const response = await roleApi.get(`/${id}`);
  return response.data;
};

export const getAllRoles = async (): Promise<
  GenericItemsResponseInterface<RoleEntityInterface>
> => {
  const response = await roleApi.get('/');
  return response.data;
};

export const addRole = async (data: Partial<RoleEntityInterface>): Promise<RoleEntityInterface> => {
  const response = await roleApi.post('/', data);
  return response.data;
};

export const deleteRole = async (id: string): Promise<RoleEntityInterface> => {
  const response = await roleApi.delete(`/${id}`);
  return response.data;
};

export const editRole = async (
  data: Partial<RoleEntityInterface>
): Promise<RoleEntityInterface> => {
  const response = await roleApi.put(`/${data.id}`, data);
  return response.data;
};

export const updatePermissions = async (
  roleId: string,
  pagePermissions?: PagePermissionEntityInterface[]
) => {
  const response = await permissionApi.put(`/role/${roleId}`, { pagePermissions });
  return response.data;
};
